import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useQuery } from "@apollo/client";
import SelectForm from "../SelectForm/SelectForm";
import { formatData } from "../../utils/helpers";
import { GET_ALL_TARIFF, GET_ALL_TAXES } from "../../graphql";

function TaxEditorFields({ taxesFormValues, onSelectChange }) {
  const { data: taxesData } = useQuery(GET_ALL_TAXES);
  const { data: tariffData } = useQuery(GET_ALL_TARIFF);

  const getSelectedTax = taxId =>
    taxesData.taxes.find(tax => Number(tax.id) === taxId);
  const getSelectedTariff = tariffId =>
    tariffData.tariff.find(tariff => Number(tariff.id) === tariffId);

  const handleTaxSelectChange = event =>
    onSelectChange({
      inputName: event.target.name,
      inputValue: getSelectedTax(Number(event.target.value)),
    });

  const handleTariffSelectChange = event =>
    onSelectChange({
      inputName: event.target.name,
      inputValue: getSelectedTariff(Number(event.target.value)),
    });

  const setSelectedTaxValues = ({ taxValue, tariffValue }) => {
    onSelectChange({
      inputName: "selectedTax",
      inputValue: taxValue,
    });
    onSelectChange({
      inputName: "selectedTariff",
      inputValue: tariffValue,
    });
  };

  useEffect(() => {
    if (!taxesFormValues || !taxesFormValues.taxId || !taxesFormValues.tariffId)
      return;
    setSelectedTaxValues({
      taxValue: getSelectedTax(Number(taxesFormValues.taxId)),
      tariffValue: getSelectedTariff(Number(taxesFormValues.tariffId)),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
        }}
      >
        <Typography fontSize={14}>Tipo de Impuesto</Typography>
        <SelectForm
          color="secondary"
          data={formatData(taxesData.taxes, "Description_Tax")}
          name="selectedTax"
          size="small"
          value={taxesFormValues?.taxId || taxesData.taxes?.[0].id}
          onChange={handleTaxSelectChange}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
        }}
      >
        <Typography fontSize={14}>Porcentaje</Typography>
        <SelectForm
          color="secondary"
          data={formatData(tariffData.tariff, "Name")}
          name="selectedTariff"
          size="small"
          value={taxesFormValues?.tariffId || tariffData.tariff?.[0].id}
          onChange={handleTariffSelectChange}
        />
      </Box>
    </React.Fragment>
  );
}

export default TaxEditorFields;

TaxEditorFields.propTypes = {
  onSelectChange: PropTypes.func,
  taxesFormValues: PropTypes.shape({
    taxId: PropTypes.number.isRequired,
    tariffId: PropTypes.number.isRequired,
  }).isRequired,
};

TaxEditorFields.defaultProps = {
  onSelectChange: undefined,
};
